/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Modal, Group, Text, Box } from '@mantine/core';

// Components
import { Button } from '@components/atoms/Button';

// Styles
import classes from './DefaultModal.module.css';

// I18n
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const DefaultModal = (props: {
	onConfirm: () => void;
	onClose: () => void;
	title: string;
	description?: string;
	opened: boolean;
	type?: 'information' | 'OKOnly' | 'question';
}) => {
	/* ******************************** HOOKS *********************************** */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */

	if (props.type == 'information') {
		return (
			<Modal
				opened={props.opened}
				onClose={props.onClose}
				classNames={classes}
				withCloseButton={false}
				size={500}
			>
				<Text
					className={clsx(
						classes.title,
						classes.informationTitle
					)}
				>
					{props.title}
				</Text>
				<Box className={classes.spacer} />
				<Text className={classes.description}>
					{props.description}
				</Text>
				<Group mt="xl" justify="center">
					<Button onClick={props.onClose}>
						{t('global.return')}
					</Button>
				</Group>
			</Modal>
		);
	}

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			classNames={classes}
			withCloseButton={false}
			size={500}
		>
			<Text className={classes.title}>{props.title}</Text>
			<Box className={classes.spacer} />
			<Text className={classes.description}>
				{props.description}
			</Text>
			<Group mt="xl" justify="center">
				<Button
					color="inputs-texts-icons"
					variant="transparent"
					onClick={props.onClose}
				>
					{t('global.cancel')}
				</Button>
				<Button onClick={props.onConfirm}>
					{t('global.iConfirm')}
				</Button>
			</Group>
		</Modal>
	);
};
